export const FETCH_EXPENSES = 'DETALIZATION:FETCH_EXPENSES';
export const FETCH_EXPENSES_SUCCESS = 'DETALIZATION:FETCH_EXPENSES_SUCCESS';
export const FETCH_EXPENSES_ERROR = 'DETALIZATION:FETCH_EXPENSES_ERROR';
export const FETCH_EXPENSES_SERVER_ERROR = 'DETALIZATION:FETCH_EXPENSES_SERVER_ERROR';

export const FETCH_PAYMENTS = 'DETALIZATION:FETCH_PAYMENTS';
export const FETCH_PAYMENTS_SUCCESS = 'DETALIZATION:FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_ERROR = 'DETALIZATION:FETCH_PAYMENTS_ERROR';

export const UPDATE_PERIOD_START = 'DETALIZATION:UPDATE_PERIOD_START';
export const UPDATE_PERIOD_END = 'DETALIZATION:UPDATE_PERIOD_END';

export const UPDATE_INTERNET_PERIOD_START = 'DETALIZATION:UPDATE_INTERNET_PERIOD_START';
export const UPDATE_INTERNET_PERIOD_END = 'DETALIZATION:UPDATE_INTERNET_PERIOD_END';

export const FETCH_EMAIL = 'DETALIZATION:FETCH_EMAIL';
export const FETCH_EMAIL_SUCCESS = 'DETALIZATION:FETCH_EMAIL_SUCCESS';
export const FETCH_EMAIL_ERROR = 'DETALIZATION:FETCH_EMAIL_ERROR';

export const FETCH_INTERNET_STATS = 'DETALIZATION:FETCH_INTERNET_STATS';
export const FETCH_INTERNET_STATS_SUCCESS = 'DETALIZATION:FETCH_INTERNET_STATS_SUCCESS';
export const FETCH_INTERNET_STATS_ERROR = 'DETALIZATION:FETCH_INTERNET_STATS_ERROR';

export const FETCH_CASHFLOW_STATS = 'DETALIZATION:FETCH_CASHFLOW_STATS';
export const FETCH_CASHFLOW_STATS_SUCCESS = 'DETALIZATION:FETCH_CASHFLOW_STATS_SUCCESS';
export const FETCH_CASHFLOW_STATS_ERROR = 'DETALIZATION:FETCH_CASHFLOW_STATS_ERROR';

export const FETCH_POSTPAID_INVOICES = 'DETALIZATION:FETCH_POSTPAID_INVOICES';
export const FETCH_POSTPAID_INVOICES_SUCCESS = 'DETALIZATION:FETCH_POSTPAID_INVOICES_SUCCESS';
export const FETCH_POSTPAID_INVOICES_ERROR = 'DETALIZATION:FETCH_POSTPAID_INVOICES_ERROR';

export const SEND_INVOICE_TO_EMAIL = 'DETALIZATION:SEND_INVOICE_TO_EMAIL';
export const SEND_INVOICE_TO_EMAIL_SUCCESS = 'DETALIZATION:SEND_INVOICE_TO_EMAIL_SUCCESS';
export const SEND_INVOICE_TO_EMAIL_ERROR = 'DETALIZATION:SEND_INVOICE_TO_EMAIL_ERROR';

export const FETCH_INVOICE_DETAILS = 'DETALIZATION:FETCH_INVOICE_DETAILS';
export const FETCH_INVOICE_DETAILS_SUCCESS = 'DETALIZATION:FETCH_INVOICE_DETAILS_SUCCESS';
export const FETCH_INVOICE_DETAILS_ERROR = 'DETALIZATION:FETCH_INVOICE_DETAILS_ERROR';

export const CHECK_EMAIL_NOTIFICATIONS = 'DETALIZATION:CHECK_EMAIL_NOTIFICATIONS';
export const CHECK_EMAIL_NOTIFICATIONS_SUCCESS = 'DETALIZATION:CHECK_EMAIL_NOTIFICATIONS_SUCCESS';
export const CHECK_EMAIL_NOTIFICATIONS_ERROR = 'DETALIZATION:CHECK_EMAIL_NOTIFICATIONS_ERROR';

export const SAVE_DETALIZATION = 'DETALIZATION:SAVE_DETALIZATION';
export const SAVE_DETALIZATION_SUCCESS = 'DETALIZATION:SAVE_DETALIZATION_SUCCESS';
export const SAVE_DETALIZATION_ERROR = 'DETALIZATION:SAVE_DETALIZATION_ERROR';

export const TOGGLE_EXPENSES_FILTER = 'DETALIZATION:TOGGLE_EXPENSES_FILTER';
export const TOGGLE_ONLY_PAID_FILTER = 'DETALIZATION:TOGGLE_ONLY_PAID_FILTER';

export const TOGGLE_PAYMENTS_DETAILS_ROW = 'DETALIZATION:TOGGLE_PAYMENTS_DETAILS_ROW';

export const MAX_REPORT_PERIOD_IN_DAYS = 31;
export const MAX_INTERNET_REPORT_PERIOD_IN_DAYS = 180;

export const EXPENSES_SECTIONS = {
  STRUCTURE: 'structure',
  DETALIZATION: 'detalization',
};

export const INTERNET_STATS_SECTIONS = {
  TRAFFIC: 'traffic',
  CASHFLOW: 'cashflow',
};

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_DATE_FORMAT = 'DD.MM.YY';

export const STATUSES = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
};

export const TABS = {
  ALL: 'all',
  UNPAID: 'unpaid',
};
